import { Box, Button, Image } from '@chakra-ui/react';
import { To, useNavigate } from 'react-router-dom';
import { useCreateJob } from '@/store/createJob';
import jobCreatedImage from '@/assets/image/job-created.svg';

export default function Success() {
  const navigate = useNavigate();
  const createJobStore = useCreateJob();

  const handleNavigation = (path: To) => {
    createJobStore.reset();
    navigate(path);
  };

  const handleGoHome = () => handleNavigation('/');
  const handleImportResume = () =>
    handleNavigation(`/job/details/${createJobStore.newJob!.job_id}?tab=candidates`);

  return (
    <Box
      w="100%"
      border="2px solid"
      borderRadius="12px"
      borderColor="neutrals.300"
      bg="background.secondary"
      py="120px"
    >
      <Box
        display="flex"
        flexDirection="column"
        p="32px"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
      >
        <Box fontWeight="bold" fontSize="36px" mb="8px">
          Job Created
        </Box>
        <Box color="neutrals.500" mb="32px">
          Your job has been successfully created.
        </Box>
        <Image src={jobCreatedImage} alt="Success" w="233px" h="233px" mb="32px" />
        <Box display="flex" justifyContent="center" w="100%">
          <Button
            bg="neutrals.0"
            color="primary.900"
            border="1px solid"
            px="30px"
            py="24px"
            borderColor="primary.900"
            borderRadius="8px"
            fontSize="16px"
            onClick={handleGoHome}
            mr="24px"
          >
            Go to home
          </Button>
          <Button
            bg="primary.900"
            color="neutrals.0"
            borderRadius="8px"
            px="30px"
            py="24px"
            fontSize="16px"
            onClick={handleImportResume}
          >
            Import resume
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
